import $http from '../../../axios-instance';
import Swal from 'sweetalert2';

export async function listarHallazgos({state, commit}, id, requestParameters = {params: state.filtro}) {
    await $http.get(`empresas/hallazgos/${id}`, requestParameters)
        .then((response) => {
            commit('setListarHallazgos', response.data.data);
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });
}

export async function listarTipoSeg({rootState, state, commit}) {

    const parametros = {
        params: {
            id_tipo_lista_chequeo: rootState.listaChequeo.selectedListaChequeo.id_tipo_lista_chequeo
        }
    };

    await $http.get('adm_general/lista-tipo-seguimiento', parametros)
        .then((response) => {
            commit('setMostrarTipoSeguimiento', response.data.data);
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });
}

export async function editarTipoSeg({state, commit}, requestParameters = {params: state.lista}) {
    await $http.get('adm_general/lista-tipo-seguimiento', requestParameters)
        .then((response) => {

            commit('setEditarTipoSeguimiento', response.data.data);
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });
}

export async function crearHallazgo({commit, state, dispatch}) {
    await $http.post(`empresas/hallazgos/crear/${state.id_empresa}`, state.hallazgoArr)
        .then((response) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: true,
                timer: 5000
            });
            commit('itemGuardado', response.data.data);
            state.error = false;
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
            commit('accionError', error.message);
        });
}

export async function mostrarHallazgo({commit, state}, id, requestParameters = {params: state.filtro_graficas}) {
    await $http.get(`empresas/hallazgos/mostrarHallazgo/${id}`, requestParameters)
        .then((response) => {
            commit('setVerHallazgo', response.data.data);
        }).catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
            commit('accionError', error.message);
        });
}

export async function actualizarHallazgo({commit, state, dispatch}) {
    $http.put(`empresas/hallazgos/editar/${state.selectedListaChequeo.id}`, state.selectedListaChequeo)
        .then((response) => {

            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: true,
                timer: 5000
            });
            dispatch('mostrarListaChequeo', state.selectedListaChequeo.id);
            state.error = false;
        }).catch((error) => {
        Swal.fire({
            position: 'center',
            icon: 'error',
            title: error.message + '<br> ' + error.errors,
            showConfirmButton: true,
            timer: 5000
        });
        commit('accionError', error.message);
    });
}

/**
 *
 * @param {*} param0
 * @param {*} requestParameters
 */
export async function verGraficas({state, commit}, requestParameters = {params: state.filtro_graficas}) {
    await $http.get('empresas/hallazgos-graficas', requestParameters)
        .then((response) => {
            commit('setGraficas', response.data);
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });
}

export async function guardarImagen({commit, state, dispatch}, data) {
    commit('dashboard/load', true, {root: true});
    await $http.post('empresas/imagen-hallazgos/crear', data, {
        headers: {'Content-Type': 'multipart/form-data'}
    })
        .then(async (response) => {
            commit('dashboard/load', false, {root: true});
            await Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Muy bien!',
                text: response.data.message,
                showConfirmButton: false,
                timer: 1000
            });
        })
        .catch(async (error) => {
            commit('dashboard/load', false, {root: true});
            await Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error',
                text: error.errors,
                showConfirmButton: true,
                timer: 3000
            });
        });
}

export async function actualizarImagen({rootState, commit, state, dispatch}, id) {

    const id_empresa = rootState.listaChequeo.selectedListaChequeo.id_empresa;

    commit('dashboard/load', true, {root: true});

    await $http.put('empresas/imagen-hallazgos/editar/' + id + '/' + id_empresa)
        .then(async (response) => {
            commit('dashboard/load', false, {root: true});
            await Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Muy bien!',
                text: response.data.message,
                showConfirmButton: false,
                timer: 1000
            });
        })
        .catch(async (error) => {
            commit('dashboard/load', false, {root: true});
            await Swal.fire({
                position: 'center',
                icon: 'error',
                title:  error.errors,
                showConfirmButton: true,
                timer: 3000
            });
        });
}


export async function listarImagenesPlaneacion({state, commit}, requestParameters) {
    await $http.get('empresas/registros', {
        params: requestParameters
    })
        .then((response) => {
            commit('setListaImagenes', response.data.data);
        }).catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
            commit('accionError', error.message);
        });
}


/**
 *
 * @param {*} param0
 * @param {*} id
 */
export async function mostrarTipoSeguimiento({dispatch, rootState, commit}, id) {
    await dispatch('tipoSeguimiento/mostrarTipoSeguimiento', id, {}, {root: true});
    commit('setMostrarTipoSeguimiento', rootState.tipoSeguimiento.tipoSeguimientos);
}

/**
 *
 * @param {*} param0
 * @param {*} page
 */
export function setPagePagination({commit, dispatch}, page) {
    commit('setPage', parseInt(page));
    dispatch('listarHallazgos');
}

/**
 * Guardar hallazgo individual
 *
 * @param {*} commit
 * @param {object} data - datos del hallazgo
 * @param {number} finding.id - ID del hallazgo
 * @param {number} finding.id_empresa - ID de la empresa
 * @param {boolean} finding.cumple - Cumple o no cumple
 * @param {string} finding.observaciones - Observaciones
 * @param {string} finding.opciones_mejora - Opciones de mejora
 * @param {string} finding.legislacion - Legislación
 * @param {string} finding.ubicacion - Ubicación
 * @returns {Promise<void>}
 *
 * @author Brandon Torres
 */
export async function saveFindings({commit}, data) {
    try {
        commit('dashboard/load', true, {root: true});
        const finding = {
            id: data.id_hallazgo,
            id_empresa: data.id_empresa,
            cumple: data.cumple,
            observaciones: data.observaciones,
            opciones_mejora: data.opciones_mejora,
            legislacion: data.legislacion,
            ubicacion: data.ubicacion
        };
        await $http.put(`edit-finding-management`, finding)
            .then((response) => {
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: response.data.message,
                    showConfirmButton: true,
                    timer: 2000
                });
            });
    } catch (error) {
        if(data.geneteError)throw new Error(error.message);
        else
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message,
                showConfirmButton: true,
                timer: 3000
            });
    } finally {
        commit('dashboard/load', false, {root: true});
    }
}


/**
 * Mostrar formulario de hallazgo por items
 *
 * @param {*} item
 * @param {*} page
 */
export function showFindinForm({commit}, item) {
    commit('setItemFinding', item);
    commit('setFindingModal', true);
}

/**
 * Mostrar formulario de hallazgo por items
 *
 * @param {*} item
 * @param {*} page
 */
export function closeFindingModal({commit, state}, data, list) {
    commit('resetItemFinding');
    commit('setFindingModal', false);
}
